import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import ErrorCenterTable from './component/ErrorCenterTable'

const ErrorCenterPage: React.FC = () => {
    return (
        <Switch>
            <Route exact path='/portal/error-center'>
                <PageTitle>Error Center</PageTitle>
                <ErrorCenterTable />
            </Route>
        </Switch>
    )
}

export default ErrorCenterPage
